/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { Durations } from '../constants';
import { ContentsDefaults, ContentsProps } from './contents';
import { AttendeeGroupsProps, AttendeeGroupsDefaults } from './attendeeGroups';
import { PricingPeriodProps, PricingPeriodDefaults } from './pricingPeriods';

export const DaySegmentProps = PropTypes.shape({
    description: PropTypes.string,
    groups: PropTypes.shape({}),
    segments: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
    name: PropTypes.string,
});

export const VehicleInfoProps = PropTypes.shape({
    description: PropTypes.string,
    fields: PropTypes.shape({}),
    license_required: PropTypes.bool,
    name: PropTypes.string,
});

export const VehicleInfoDefaults = {
    description: '',
    fields: {},
    license_required: false,
    name: '',
};

export const WatercraftInfoProps = PropTypes.shape({
    description: PropTypes.string,
    fields: PropTypes.shape({}),
    license_required: PropTypes.bool,
    name: PropTypes.string,
});

export const WatercraftInfoDefaults = {
    description: '',
    fields: {},
    license_required: false,
    name: '',
};

export const PassTypeProps = PropTypes.shape({
    contents: ContentsProps,
    created_at: PropTypes.string,
    duration: PropTypes.oneOf(Object.keys(Durations)),
    facility_id: PropTypes.string,
    facility_type: PropTypes.string,
    features: PropTypes.shape({
        'attendee-info': AttendeeGroupsProps,
        'day-segment': DaySegmentProps,
        'equipment-info': PropTypes.shape({
            vehicle: PropTypes.shape({
                'no-vehicle': VehicleInfoProps,
                'personal-vehicle': VehicleInfoProps,
                'rental-vehicle': VehicleInfoProps,
                'commercial-vehicle': VehicleInfoProps,
                'motor-coach': VehicleInfoProps,
                'mini-bus': VehicleInfoProps,
                van: VehicleInfoProps,
                camper: VehicleInfoProps,
            }),
            watercraft: PropTypes.shape({
                'no-boat': WatercraftInfoProps,
                'motorized-boat': WatercraftInfoProps,
                'non-motorized-boat': WatercraftInfoProps,
                'rental-boat': WatercraftInfoProps,
            }),
        }),
        'start-date': PropTypes.bool,
        'is-commercial-pass': PropTypes.bool,
        'duration-of-visit': PropTypes.bool,
        'bus-number': PropTypes.bool,
        'number-of-passengers': PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({
                min: PropTypes.number,
                max: PropTypes.number,
            }),
        ]),
    }),
    id: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    periods: PropTypes.arrayOf(PricingPeriodProps),
    sales_available_end: PropTypes.string,
    sales_available_start: PropTypes.string,
    sku: PropTypes.string,
    updated_at: PropTypes.string,
    used_for: PropTypes.string,
});

export const PassTypeDefaults = {
    contents: ContentsDefaults,
    created_at: '',
    duration: 'annual',
    facility_id: null,
    facility_type: null,
    features: {
        'attendee-info': AttendeeGroupsDefaults,
        'equipment-info': {
            vehicle: {
                'no-vehicle': VehicleInfoDefaults,
            },
            watercraft: {
                'no-boat': WatercraftInfoDefaults,
            },
        },
        'start-date': false,
        is_field_sales: false,
    },
    id: null,
    image: '',
    name: '',
    periods: PricingPeriodDefaults,
    sales_available_end: '',
    sales_available_start: '',
    sku: '',
    updated_at: '',
    used_for: '',
};
